(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementDialogController', AgreementDialogController);

    AgreementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Agreement', 'Event', 'AgreementValuation', 'Product'];

    function AgreementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Agreement, Event, AgreementValuation, Product) {
        var vm = this;
        vm.agreement = entity;
        vm.events = Event.query();
        vm.agreementvaluations = AgreementValuation.query();
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:agreementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.agreement.id !== null) {
                Agreement.update(vm.agreement, onSaveSuccess, onSaveError);
            } else {
                Agreement.save(vm.agreement, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
